function Finance(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">경영</h4>
                <h5 className="recruit_titleline_title">재무</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">재무팀은</p>
                <ol className="recruit_subinfo_list">
                    <li className="recruit_subinfo_list_inner">기업회계기준(K-IFRS)에 따라 본사 및 자회사의 연결회계결산을 수행하고</li>
                    <li className="recruit_subinfo_list_inner">회계감사에 대응하는 회계업무와</li>
                    <li className="recruit_subinfo_list_inner">세법 및 조세정책을 기반으로 조세를 납부하는 세무업무</li>
                    <li className="recruit_subinfo_list_inner">각종 자금과 비용의 흐름을 관리하는 자금업무를 수행합니다. 그리고</li>
                    <li className="recruit_subinfo_list_inner">회사의 사업내용이나 재무상황 등을 이해관계자에게 알리는 공시업무와</li>
                    <li className="recruit_subinfo_list_inner">투자자들에게 기업의 정보를 제공하는 IR 업무도 수행하고 있습니다. </li>
                </ol>
                <p className="recruit_subinfo_text">
                    대부분의 업무가 월별, 분기별로 정해진 일정에 맞춰 규칙적으로 수행되며,
                    사내·외 이해관계자들에게 경영활동과 관련된 재무정보를<br />제공합니다.
                    회계 및 세무에 대한 기본 지식이 재무팀에서의 원활한 업무 수행에 필요합니다.<br />
                    그리고 숫자를 다루기 때문에 꼼꼼함이 필수입니다. 회사 내 다양한 회계처리에 대해 꼼꼼하게 확인하고 오류가 있는지
                    검증해야 하기<br />때문입니다. 의사소통능력 또한 중요합니다. 결국, 현업 부서와의 의사소통을 통해 업무를 수행하기 때문입니다.<br />
                    마지막으로, 상황에 따라 필요한 정보를 도출해내기 위해 엑셀 프로그램이나 회계 시스템을 다룰 수 있는 IT 활용 능력도 필요합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 재무팀은 회계업무 및 세무업무, 자금업무와 공시·IR 업무를 담당하고 있습니다.
                </p>
                <em className="recruit_bold_text">회계</em>
                <p className="recruit_subinfo_text">
                    기업회계기준(K-IFRS)에 따라 매월 결산을 통해 손익을 보고하고, 분기 결산 시 별도/연결재무제표 작성, 주석 등 공시 자료를 작성하고<br />
                    외부회계 감사에 대응합니다.
                </p>
                <em className="recruit_bold_text">자금</em>
                <p className="recruit_subinfo_text">
                    조직 운영에 필요한 자금의 입금 및 지급 관리를 하고, 현금흐름을 원활하게 유지하고 관리하는 업무입니다.
                </p>
                <em className="recruit_bold_text">세무</em>
                <p className="recruit_subinfo_text">
                    법인세, 부가세, 원천세 담당자가 각종 세법과 처리 규정 등을 검토하여 회사 관리지침을 수립하고 세금 신고 및 납부 등을 관리합니다.
                </p>
                <em className="recruit_bold_text">공시·IR</em>
                <p className="recruit_subinfo_text">
                    사업내용이나 재무상황, 영업실적 등 기업의 내용을 투자자 등 이해관계자에게 알리는 공시업무와
                    자본시장에서 회사가 정당한 평가를<br />얻기 위하여 투자자들을 대상으로 SBS에 대한 정보를 제공하는 IR 업무를 하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    회사경영에서 재무팀의 업무는 가장 기본적이고 필수적인 업무이고, 재무팀에서 제공하는 재무정보는 내부 이해관계자들의 의사결정에<br />
                    큰 영향을 미치게 됩니다. 재무팀에서는 회계 및 세무, 자금, 공시 및 IR 등의 업무를 경험할 수 있고, 업무수행 중 습득하는 지식을 바탕으로<br />
                    자기 계발을 통해 역량을 키운다면 회계사, 세무사 등의 전문자격 취득까지도 바라볼 수 있습니다.<br />
                    <br />
                    이렇게, 재무팀에서 자신의 업무 경력을 쌓아가면 향후 조직 내 어느 팀에 가더라도 환영받을 수 있고,
                    맡은 바 업무를 수행할 때 큰 도움이<br />됩니다. 또한, 재무 업무를 경험함으로써 경영관리의 가장 중요한 부분을 차지하는
                    재무에 대한 이해를 통해 향후 유능한 관리자의 길을 걸을 수 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 재무팀에서 회계 및 세무 업무를 담당하고 있는 허필규입니다.<br />
                    회계 업무의 특성상 월 단위로 이뤄지는 결산을 중심으로 업무를 수행하고 있고, 분기에는 회계감사 대응 및 분기 사업보고서 작성에<br />
                    필요한 자료를 만듭니다. 그리고 세무업무 중 법인세를 담당하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">재무담당자가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    대학교 시절에 회계와 세법 강의를 들으면서 이 분야에 흥미가 생겼고, 재무 업무 특성상 인내심과 꼼꼼함이 필요한데
                    그게 제 성격과<br />잘 맞는다고 생각했습니다. 재무팀은 내·외부 이해관계자들에게 회사의 정확한 재무정보를 제공해야 하고,
                    회사의 시작과 끝을 담당하는<br />중요한 부서라고 생각해서 재무팀을 지원하였습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    재무팀의 기본업무는 현업부서에서 처리한 거래 내용에 대한 검토와 확인입니다.<br />
                    현업이 새로운 상황이나 어려운 상황에 부딪혔을 때, 재무적 관점에서 그 상황을 검토하고 다양한 의사소통을 통해
                    업무가 잘 진행되었을 때<br />보람을 느낍니다.
                    또한, 법인세 업무를 담당하면서 매년 바뀌는 세액공제 중 회사에 해당하는 세액공제를 찾아내어 절세함으로써
                    회사에<br />기여했을 때 법인세 담당자로서 큰 보람을 느꼈습니다.
                    회사의 업무 프로세스 중 잘못된 부분을 개선해서 내부 이해관계자들에게 신속하고<br />정확한 정보를 제공했을 때에도 보람을 느꼈습니다. 정리하다 보니 일하면서 많은 보람을 느끼고 있네요^^
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    SBS 재무팀은 팀 분위기 및 팀워크가 매우 좋습니다. 결산할 때 각자 맡은 바 업무를 하면서 잘못된 부분이 없는지 서로 챙겨주고,<br />
                    회계 혹은 세무 이슈가 생겼을 때는 다 같이 해결방안을 모색합니다. 재무팀 업무는 대부분 일정이 있고,
                    일정 수준 정형화되어 있기 때문에<br />워라밸을 지키기에도 좋은 팀입니다.
                    더군다나 SBS는 급여 및 복리후생도 업계 최고 수준이기 때문에 입사하게 되면 만족도가 높을 것으로<br />생각합니다.
                </p>
            </div>
        </div>);
}

export default Finance;